export default __webpack_public_path__ + "static/media/no-mistakes-illustration-blob-top.bc8f2b47.svg";